import _ from 'lodash';

export const roomClassOptions = [
  { label: 'Poolside Suites', value: 61 },
  { label: 'Premium Suites', value: 78 },
  { label: 'Premium Guest Rooms', value: 81 },
  { label: 'Standard Guest Rooms', value: 82 },
  { label: 'Suites', value: 3 },
  { label: 'Accessible', value: 1 },
];

export const getRoomClassOptionsByCodes = (roomClassCodes) => {
  return roomClassCodes && roomClassCodes.length > 0
    ? _.filter(roomClassOptions, (option) =>
        _.includes(roomClassCodes, option.value)
      )
    : [];
};

export const getAvailRoomClassOptions = (rooms) => {
  const availRoomClassSet = _.reduce(
    rooms,
    (acc, room) => {
      if (_.get(room, 'roomClassificationCode') && !acc.has(_.get(room, 'roomClassificationCode'))) {
        acc.add(_.get(room, 'roomClassificationCode'));
      }
      if (_.get(room, 'viewExtensions.isAccessible') && !acc.has(1)) {
        acc.add(1)
      }
      return acc;
    },
    new Set()
  );

  const availRoomClassCodes = Array.from(availRoomClassSet);
  const AvailRoomClassOptions = _.filter(roomClassOptions, (option) =>
    _.includes(availRoomClassCodes, option.value)
  );

  return AvailRoomClassOptions;
};



// WEBPACK FOOTER //
// ./src/utilities/content/roomClassFilter.js